import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../../store';
import * as PIXI from 'pixi.js';
import CollapsibleSwitchListItem from '../../../../../../list-items/CollapsibleSwitchListItem';
import CreatePageConstants from '../../../../CreatePageConstants';
import TextGlowBlurListItem from './TextGlowBlurListItem';
import TextGlowScaleListItem from './TextGlowScaleListItem';
import CondensedListItem from '../../../../../../list-items/CondensedListItem';

const TextGlowListItem = (props) => {
    const { glowSettingsEnabled, updateTextElement, index } = props;

    const onGlowEnabledChange = (value) => updateTextElement(index, { 
        glowSettings: { enabled: value }
    });
    
    return (
        <CollapsibleSwitchListItem
            checked={glowSettingsEnabled}
            text='Glow'
            onChange={onGlowEnabledChange}
            warning={PIXI.utils.isWebGLSupported() ? null : CreatePageConstants.LIMITED_VISIBILITY_WARNING_TEXT}
            dense={false}
        >
            <List dense disablePadding>
                <CondensedListItem
                    elements={[
                        {
                            width: 6,
                            component: <TextGlowBlurListItem index={index} />
                        },
                        {
                            width: 6,
                            component: <TextGlowScaleListItem index={index} />
                        }
                    ]}
                />
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state, ownProps) => {
    const element = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const glowSettingsEnabled = element && element.glowSettings ? element.glowSettings.enabled : false;
    return { glowSettingsEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextGlowListItem);
